import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import DataProtectionSoftwareService from "src/modules/data-protection/apis/DataProtectionSoftwareService";

export const COMPLIANCE_MODULE_SLUGS = {
    aiRiskAssessment: "ai_risk_assessment",
    processingActivity: "processing_activity",
    riskAssessment: "risk_assessment",
    dpia: "data_protection_impact_assessment",
    fria: "fria_assessment"
};

/**
 * Loads the additive compliance-module payload for one assessment. Only the
 * active tab should enable this, so the details page never refetches in a loop.
 */
const useComplianceModule = (softwareId, slug, { enabled = true, t } = {}) => {
    return useQuery({
        queryKey: ["gdpr-software-compliance-module", softwareId, slug],
        queryFn: async () => {
            const service = DataProtectionSoftwareService.getInstance();

            return await service.complianceModule(softwareId, slug);
        },
        enabled: Boolean(softwareId && slug && enabled),
        refetchOnWindowFocus: false,
        onError: (error) => {
            if (process.env.NODE_ENV === "development") {
                console.error(error);
            }

            toast(
                t
                    ? t("An error occurred while fetching assessment summary.")
                    : "An error occurred while fetching assessment summary.",
                {
                    type: "error"
                }
            );
        }
    });
};

export default useComplianceModule;
